import { useSelector } from "react-redux";
import { Badge, Group, Tooltip} from '@mantine/core';
import intl from "react-intl-universal";



export function DocReadCount() {
  const initdocs = useSelector((state: any) => state.user.meetingdocs)

  let countreaddocs
  countreaddocs = initdocs.filter((obj: { isToBeRead: boolean; }) => {
    return obj.isToBeRead === true
  });
  let countdonereaddocs
  countdonereaddocs = initdocs.filter((obj: { isReadOut: boolean; isToBeRead: boolean; }) => {
    return obj.isReadOut === true && obj.isToBeRead === true
  });
  
  const readdocsArray:any = Object.values(countreaddocs);
  const donereaddocssArray:any = Object.values(countdonereaddocs);

  return (
    <>
    <Group>
    <Tooltip label={intl.get('DOCCOUNT_ALL')} multiline={true}>
        <Badge color="gray" variant="outline">{readdocsArray.length}</Badge>
    </Tooltip>
    <Tooltip label={intl.get('DOCCOUNT_CONFIRM')} multiline={true}>
        <Badge color="green" variant="outline">{donereaddocssArray.length}</Badge>
        </Tooltip>
   </Group>
    </>
  );
}